import { FeaturesConfig } from "../config";
import { featuresCommon } from "./featuresCommon";

export const featuresDev: FeaturesConfig = {
  ...featuresCommon,
  baseURL: "https://b2b-app.dev-gcp.fena.co",
  environment: "develop",

  app: {
    ...featuresCommon.app,
    appName: "fena-b2b-wholesale-devgcp",
  },

  cloudConfig: {
    provider: "gcp",
    gcp: {
      projectId: "prj-workload-dev",
      region: "europe-west2",
      integrationStorageBucket: "fena-integrations-api-dev",
      toolkitStorageBucket: "fena-toolkit-backend-dev",
      pubsub: {
        idMapSyncTopic: "batch-job-apps-id-maps-file-sync",
        bulkSyncTopic: "batch-job-apps-bulk-sync",
      },
    },
  },

  sentry: {
    dsn: "https://61e65270aaa75e920bc451c9a0221df9@o1222258.ingest.us.sentry.io/4510467293249536",
  },
};
